// @ts-nocheck
import React, { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiTextField-root': {
            margin: '8px',
            width: '100%',
        },
    },
}))

export function useForm(initialState) {

    const [values, setValues] = useState(initialState);

    const handleInputChange = (index, e) => {
        if (index !== undefined) {
            let destinatarios = values.destinatarios;
            values.destinatarios[index] = e.target.value;
            setValues({
                ...values,
                destinatarios
            });
        } else {

            const { name, value } = e.target;
            setValues({
                ...values,
                [name]: value
            });
        }
    }

    return { values, setValues, handleInputChange }
}

/**
 * Definiendo un componente Form podemos aplicar los mismos estilos a todos los formularios
 * que necesitemos crear en sinap y reutilizar el componente
 * @param props
 * @returns {*}
 * @constructor
 */
export function Form(props) {

    const classes = useStyles();
    const { onSubmit } = props;

    return (
        <>
            <form onSubmit={onSubmit} className={classes.root}>
                {props.children}
            </form>
        </>
    )
}

export function FormWithoutStyle(props) {
    const { onSubmit } = props;

    return (
        <>
            <form onSubmit={onSubmit}>
                {props.children}
            </form>
        </>
    )
}
